import { useEffect, useState } from "react";
import {
    FaUserCircle,
    FaCamera,
    FaUser,
    FaEnvelope,
    FaPhone,
} from "react-icons/fa";

import {
    getProfile,
    updateProfile,
} from "../services/profileService";

import "./PersonalInformation.css";

function PersonalInformation() {

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [form, setForm] = useState({

        name: "",

        email: "",

        phone: "",

    });

    useEffect(() => {

        loadProfile();

    }, []);

    const loadProfile = async () => {

        try {

            const res = await getProfile();

            if (res.success) {

                setForm({

                    name: res.user.name || "",

                    email: res.user.email || "",

                    phone: res.user.phone || "",

                });

            }

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value,

        });

    };

    const handleSubmit = async () => {

        try {

            setSaving(true);

            const res = await updateProfile({

                name: form.name,

                phone: form.phone,

            });

            alert(res.message);

        } catch (error) {

            alert(

                error.response?.data?.message ||

                "Failed to update profile."

            );

        } finally {

            setSaving(false);

        }

    };

    if (loading) {

        return (

            <div className="profile-loading">

                Loading...

            </div>

        );

    }

    return (

        <div className="profile-page">

            <div className="profile-card">

                {/* ========================= */}
                {/* Top Section */}
                {/* ========================= */}

                <div className="profile-top">

                    <div className="profile-image">

                        <FaUserCircle />

                        <button>

                            <FaCamera />

                        </button>

                    </div>

                    <h2>

                        Personal Information

                    </h2>

                    <p>

                        Manage your HomeFoods profile

                    </p>

                </div>

                {/* ========================= */}
                {/* Form */}
                {/* ========================= */}

                <div className="profile-form">

                    <div className="input-box">

                        <FaUser />

                        <input

                            name="name"

                            value={form.name}

                            onChange={handleChange}

                            placeholder="Full Name"

                        />

                    </div>

                    <div className="input-box">

                        <FaEnvelope />

                        <input

                            value={form.email}

                            disabled

                        />

                    </div>

                    <div className="input-box">

                        <FaPhone />

                        <input

                            name="phone"

                            value={form.phone}

                            onChange={handleChange}

                            placeholder="Phone Number"

                        />

                    </div>

                    <button

                        className="save-btn"

                        onClick={handleSubmit}

                        disabled={saving}

                    >

                        {

                            saving

                                ? "Saving..."

                                : "Save Changes"

                        }

                    </button>

                </div>

            </div>

        </div>

    );

}

export default PersonalInformation;